<template>
  <div class="volunteerBox" v-show="info">
    <Download></Download>
    <div class="contentBox">
      <div class="bg">
        <img src="@/assets/img/h5/teacherbg.png" alt="">
         <div class="header">
            <img class="img" :src="info.image" alt="" />
          </div>
      </div>
      <div class="main">
        <div class="topInfo">
          <div class="Info">
            <div class="nameBox">
              <div class="name">{{ info.name }}</div>
              <div class="opation">
                <span class="subscribe" @click="opation('subscribe')"
                  >关注</span
                >
              </div>
            </div>
            <div class="slogan">
              <span> {{info.levelcn}}</span> 
              
              <!-- <img src="@/assets/img/h5/arrow_r_g.png" alt="">  -->
            </div>
            <div class="org" @click="goto('agency')">
              <span>{{info.organization&&info.organization.name?info.organization.name:''}}</span>
              <img src="@/assets/img/h5/arrow_r_h.png" alt /> 
              </div>
             <div class="scoreBox">
                <div class="score">
                  <i
                    class="full"
                    v-for="(item1, index1) in startBox[1]"
                    :key="index1"
                  ></i>
                  <i
                    class="half"
                    v-for="(item1, index1) in startBox[2]"
                    :key="index1"
                  ></i>
                  <i
                    class="none"
                    v-for="(item1, index1) in startBox[0]"
                    :key="index1"
                  ></i>
                  <span>{{
                    util.toFixed(
                      info.evaluationcount > 0
                        ? info.staringcount / info.evaluationcount
                        : 5,
                      1
                    )
                  }}</span>
                </div>
                <span>{{ info.evaluationcount? util.showCount(info.evaluationcount) + '条评价' :'暂无评价' }}</span>
              </div>
          </div>
          <div class="location" @click="opation('address')">
             <div class="address">
              <div><i class="locationicon"></i></div>
              <div class="addtext">
                <span class="">{{info.adress}}</span>
                <i class="arrow"></i>
              </div>
              
             </div>
             <!-- <div class="org">
              <span>{{info.organization&&info.organization.name?info.organization.name:''}}</span>
              <i class="arrow"></i>
             </div> -->
             
            <!--  -->
          </div>
        </div>
        <div class="graybg"></div>
        <div class="swiperInfo">
          <div class="nav">
            <Nav :navList="navList" :center="center" :navIndex="navIndex" @changeNavCallBack="changeNavCallBack"></Nav>
          </div>
          <div class="swiper">
              <swiper
              ref="courseSwiper"
              :options="mySwiperOption"
              class="swiper-wrapper"
            >
              <swiper-slide v-for="(item,index) in navList" :key="index">
                <div v-if="index==0" class="person">
                  <div class="skill common">
                    <div class="title">专业擅长</div>
                    <div class="content">
                      {{info.specialty}}
                    </div>
                  </div>
                  <div class="profile common">
                    <div class="title">个人简介</div>
                    <div class="content">{{info.profile}}</div>
                  </div>
                </div>
                <div v-if="index==1" class="course">
                  <div class="online" v-if="coursecount">
                    <div class="commonTop">
                      <div class="topLeft">
                        <span class="title"
                          >线上课程 <em>({{ coursecount }})</em></span
                        >
                      </div>
                      <div class="topRight">
                        <span class="more" @click="goto('online')">查看更多</span>
                      </div>
                    </div>
                    <div class="commonContent">
                      <!-- <div class="filter">
                        <ul>
                          <li
                            v-for="(item, index) in filter"
                            :key="index"
                            :class="filterIndex == index ? 'active' : ''"
                            @click="filterIndex = index"
                          >
                            {{ item.name }}
                          </li>
                        </ul>
                      </div> -->
                      <div class="courseList" v-if="course.length > 0">
                        <ul>
                          <li
                            v-for="(item, index) in course"
                            :key="index"
                            @click="goto('courseDetail', item)"
                          >
                            <Components
                              type="course"
                              :data="item"
                              :otherData="{ showTeacher: true }"
                            ></Components>
                          </li>
                        </ul>
                      </div>
                      <div class="notData" v-else>
                        <p>暂无相关课程内容</p>
                      </div>
                    </div>
                  </div>
                  <div class="traning" v-if="trainingcount">
                     <div class="commonTop">
                      <div class="topLeft">
                        <span class="title"
                          >线下培训 <em>({{ trainingcount }})</em></span
                        >
                      </div>
                      <div class="topRight" >
                        <span class="more" @click="goto('training')">查看更多</span>
                      </div>
                    </div>
                    <div class="commonContent">
                      <!-- <div class="filter">
                        <ul>
                          <li
                            v-for="(item, index) in filter"
                            :key="index"
                            :class="filterIndex == index ? 'active' : ''"
                            @click="filterIndex = index"
                          >
                            {{ item.name }}
                          </li>
                        </ul>
                      </div> -->
                      <div class="courseList" v-if="training.length > 0">
                        <ul>
                          <li
                            v-for="(item, index) in training"
                            :key="index"
                            @click="goto('courseDetail', item)"
                          >
                            <Components
                              type="training"
                              :data="item"
                              :otherData="{ showTeacher: true }"
                            ></Components>
                          </li>
                        </ul>
                      </div>
                      <div class="notData" v-else>
                        <p>暂无相关课程内容</p>
                      </div>
                    </div>
                  </div>
                  
                 <NotData style="padding:20px 0;" v-if="!coursecount & !trainingcount" className="online" title="暂无培训课程"></NotData>
                </div>
                <div v-if="index==2" class="interact">
                  <div class="online box_common" v-if="onlinecomment && onlinecomment.length">
                    <div class="title">线上点评</div>
                    <div class="paycontent">
                      <ul>
                        <li v-for="(item,index) in onlinecomment" :key="index">
                          <div class="pay ">
                            <div class="payTitle">
                              <span class="producetitle ellipsis">{{handleTex(item.productname)}}</span><span class="price">{{item.sellingprice? '¥' + item.sellingprice : '免费'}}</span>
                            </div>
                            <div class="txt">{{item.infomessage}}</div>
                          </div>
                          <div class="opration" @click="opation('enroll')">预约</div>
                        </li>
                      </ul>
                    </div>
                    <!-- <div class="title">线上点评</div>
                    <div class="paycontent">
                      <ul>
                        <li v-for="(item,index) in onlinecomment" :key="index">
                          <div class="pay">
                            <div class="payTitle">
                              <span>{{item.productname}}</span><span class="price">{{item.sellingprice? '¥' + item.sellingprice : '免费'}}</span>
                            </div>
                            <div class="txt">{{item.infomessage}}</div>
                          </div>
                          <div class="opration">预约</div>
                        </li>
                      </ul>
                    </div> -->
                  </div>
                  <div class="face box_common" v-if="facetoface && facetoface.length">
                    <div class="title">1v1面授</div>
                    <div class="paycontent">
                      <ul>
                        <li v-for="(item,index) in facetoface" :key="index">
                          <div class="pay ">
                            <div class="payTitle">
                              <span class="producetitle">{{handleTex(item.productname)}}</span><span class="price">{{item.sellingprice? '¥' + item.sellingprice : '免费'}}</span>
                            </div>
                            <div class="txt">{{item.infomessage}}</div>
                          </div>
                          <div class="opration" @click="opation('enroll')">预约</div>
                        </li>
                      </ul>
                    </div>
                  </div>
                   <NotData v-if="onlinecomment && !onlinecomment.length && facetoface && !facetoface.length" className="teacher" title="暂无互动教学"></NotData>
                </div>
                <div v-if="index==3" class="evaluation">
                 <div class="commonContent">
                    <ul v-if="evaluationTotal">
                      <li v-for="(item, index) in evaluation" :key="index">
                        <Components
                          type="evaluation"
                          :data="item"
                          :otherData="{ type: 'volunteer' }"
                          @componentsPopUp="componentsPopUp"
                        ></Components>
                      </li>
                    </ul>
                    <div class="notDataBox" v-else>
                      <NotData style="margin-top:20px;" className="evaluation" title="暂无服务评价"></NotData>
                    </div>
                  </div>
                </div>
              
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Components from "./components/components.vue";
import NotData from "@/components/notData";
import Download from "@/components/download.vue";
import Nav from '@/components/nav.vue'
export default {
  name: "volunteers",
  metaInfo() {
    return {
      title: this.info.name,
    };
  },
  data() {
    return {
      //  3000: 1v1面授； 2000: 线上点评； 2001:视频连线
      onlinecomment:[], 
      facetoface:[],
      center:'center',
      navIndex:0,
      teacherId: "",
      info: "",
      more: false,
      showMore: false,
      teaching: [],
      course: [], //线上课程
      training:[], //线下培训
      coursecount: 0,
      trainingcount: 0,
      filterIndex: 0,
      filter: [
        { name: "全部", value: "" },
        { name: "在线课程", value: "1000" },
        { name: "面授课程", value: "2000" },
      ],
      navList: [
        {
          name:'个人简介',
        },
         {
          name:'培训课程',
        },
         {
          name:'互动教学',
        },
         {
          name:'服务评价',
        },
      ],
       mySwiperOption : {
          // autoplay: 5000,
          noSwiping: true,
          // loop: true,
          autoHeight: true,
          // onSlideChangeStart: function (swiper) {
          //   this.courseCurrentIndex = swiper.activeIndex;
          // }.bind(this),
          onSlideChangeEnd: function (swiper) {
            this.navIndex = swiper.activeIndex
            // this.$refs.courseSwiper.swiper.slideTo(0, 200, false);
          //  this.courseCurrentIndex = swiper.activeIndex
          // console.log(swiper.activeIndex,'index',this)

        }.bind(this),
      },
      agencyInfo: "",
      evaluation: [],
      evaluationTotal: 0,
      startBox: [],
      teacherType: [],
    };
  },
  components: {
    Components,
    NotData,
    Download,
    Nav,
  },
  watch: {
    ["filterIndex"]() {
      // this.getCourse()
      // this.getTraning()
    },
  },
  created() {
    if (this.$store.state.state.teacherType&&this.$store.state.state.teacherType.length == 0) {
      this.getTeacherType();
    } else {
      this.teacherType = this.$store.state.state.teacherType;
    }
  },
  mounted() {
    this.teacherId = this.$route.query.teacherId;
    this.util.showLoading();
    this.getInfo();
  },
  methods: {
    handleTex (str) {
      return str.replace('(45min)','').replace('(90min)','')
    },
     changeNavCallBack (index) {
      this.navIndex = index
      this.$refs.courseSwiper.swiper.slideTo(index, 200, false);
    },
    componentsPopUp(data) {
      var url = "",
        obj = {};
      switch (data.type) {
        case "course":
          if (data.businesstype == 1000) {
            url = "/h5/course/publicCourseDetails";
            obj.courseid = data.id;
          } else if (data.businesstype == 1001) {
            url = "/h5/course/payCourseDetails";
            obj.courseid = data.id;
          } else if (data.businesstype == 1005) {
            url = "/h5/course/belowCourseDetails";
            obj.adjcourseid = data.id;
          }
          break;
        case "teacher":
          window.location.hash = "#teaching";
          break;

        default:
          break;
      }
      if (url) {
        this.$router.push({ path: url, query: obj });
      }
    },
    getTeacherType() {
      var obj = {
        domainname: "TEACHERTYPE",
      };
      this.$post("/gart-common-api/api/cmn/domaindata/index", obj).then(
        (res) => {
          if (res.code == 1) {
            var data = res.data ? res.data : [];
            this.$store.commit("uploadTeacherType", data);
          } else {
            this.util.toast({ msg: res.message });
          }
        }
      );
    },
    getInfo() {
      var obj = {
        teacherid: this.teacherId,
      };
      this.$post(
        "/gart-common-api/api/crm/teacher/queryTeacherDetail",
        obj
      ).then((res) => {
        this.util.hideLoading();
        if (res.code == 1) {
          if (res.data.rtncode == 1) {
            var data = res.data;
            this.info = data;
            var star =
              data.evaluationcount > 0
                ? data.staringcount / data.evaluationcount
                : 5;
            this.startBox = this.util.changeStart(star);
            this.agencyInfo = data.organization;
            if (res.data && res.data.schedulingprices && res.data.schedulingprices.length) {
              this.handleList(res.data.schedulingprices)
            }
            this.showTeaching();
            this.getCourse();
            this.getTraning()
            this.getEvaluation();
            this.shareLink();
          } else {
            this.util.toast({ msg: res.data.rtnmsg });
          }
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
    handleList (list) {
      list.forEach((item) => {
        if (item.schedulingtype == '2000' ||item.schedulingtype == '2001') {
          this.onlinecomment.push(item)
        }else if (item.schedulingtype == '3000') {
          this.facetoface.push(item)
        }
      })
    },
    showTeaching() {
      var _this = this;
      var teaching = this.info.schedulingprices;
      var nameList = ["线下一对一", "作品点评", "视频连线"];
      var typeList = [3000,3001, 2000, 2001];
      for (var i = 0; i < teaching.length; i++) {
        var index = typeList.indexOf(teaching[i].schedulingtype);
        this.teaching.push({
          name: nameList[index==0?0:index-1],
          des: teaching[i].infomessage,
          price:"¥" +teaching[i].sellingprice +(teaching[i].schedulingtype == 3000||teaching[i].schedulingtype == 3001 ? "起" : ""),
        });
      }
      setTimeout(() => {
        if (
          _this.$refs.profileHtml.offsetHeight >
          _this.$refs.profile.offsetHeight
        ) {
          _this.more = true;
        }
      }, 20);
    },
    getCourse() {
      var obj = {
        pageNum: 1,
        pageSize: 3,
        type:'1000',
        teacherid: this.teacherId,
        organizationid: this.info.organizationid,
        lclasscode:'',
        coursetype: '1000',
      };
      this.$post("/gart-common-api/api/scm/course/queryOrganizationCoursForEs", obj).then(
        (res) => {
          if (res.code == 1) {
            this.course = res.data && res.data.rows ? res.data.rows : [];
            this.coursecount = res.data && res.data.total ? res.data.total : 0
          } else {
            this.util.toast({ msg: res.message });
          }
        }
      );
    },
    getTraning() {
      var obj = {
        pageNum: 1,
        pageSize: 3,
        type:'1000',
        teacherid: this.teacherId,
        organizationid: this.info.organizationid,
        lclasscode:'',
        coursetype: '2000',
      };
      this.$post("/gart-common-api/api/scm/course/queryOrganizationCoursForEs", obj).then(
        (res) => {
          if (res.code == 1) {
            this.training = res.data && res.data.rows ? res.data.rows : [];
            this.trainingcount = res.data && res.data.total ? res.data.total : 0
          } else {
            this.util.toast({ msg: res.message });
          }
        }
      );
    },
    getEvaluation() {
      var obj = {
        teacherid: this.teacherId,
        pageNum: 1,
        pageSize: 3,
      };
      this.$post(
        "/gart-common-api/api/crm/customercomment/queryByComment",
        obj
      ).then((res) => {
        if (res.code == 1) {
          if (res.data.rtncode == 1) {
            var data = res.data && res.data.rows ? res.data.rows : [];
            this.evaluation = data;
            this.evaluationTotal = res.data.total;
          } else {
            this.util.toast({ msg: res.data.rtnmsg });
          }
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
    showAll() {
      this.showMore = !this.showMore;
    },
    opation(type) {
      switch (type) {
        case "subscribe":
        case "reservation":
        case 'enroll':
          this.util.downLoad(this, { open: true });
          break;
        case 'address':
          let addressInfo = this.info.organization
          window.location.href =`https://uri.amap.com/marker?position=${addressInfo.locationx},${addressInfo.locationy}&name=${addressInfo.name}`
          break;
        case 'org':
          
          break;
        default:
          break;
      }
    },
    goto(type, data) {
      var obj = {},
        url = "";
      switch (type) {
        case "online":
        case "training":
          url = "/h5/serve/courseList";
          obj = {
            id: this.teacherId,
            type: type,
            from : 'volunteer'
          };
          break;
        case "courseDetail":
          if (data.coursetype == 2000) {
            url = "/h5/course/belowCourseDetails";
            obj.adjcourseid = data.courseid;
          } else if (data.coursetype == 1001) {
            url = "/h5/course/payCourseDetails";
            obj.courseid = data.courseid;
          } else if (data.coursetype == 1000) {
            url = "/h5/course/publicCourseDetails";
            obj.courseid = data.courseid;
          }
          break;
        case "evaluation":
          url = "/h5/serve/evaluationList";
          obj = {
            id: this.teacherId,
            type: "volunteer",
          };
          break;
        case "agency":
          url = "/h5/serve/agency";
          obj = {
            teamInfoId: this.agencyInfo.teaminfoid,
          };
          break;

        default:
          break;
      }
      if (url) {
        this.$router.push({
          path: url,
          query: obj,
        });
      }
    },
    shareLink() {
      var _this = this;
      var url = _this.$store.state.state.shareUrl;
      url += "#/h5/serve/volunteers?teacherId=" + this.teacherId;
      var data = {
        title: this.info.sharetitle,
        desc: this.info.signature ? this.info.signature : "", // 分享描述
        url: url,
        imgUrl: this.info.shareicon,
      };
      this.util.shareLink(this, data).then(function () {});
    },
  },
  beforeDestroy() {
    this.util.hideLoading();
  },
};
</script>

<style lang="scss" scoped>
.contentBox {
  // background: #F6F7F8;
  height: 100vh;
  .bg {
    position: relative;
    .header {
      position: absolute;
      left: 16px;
      bottom: -40px;
      img {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          border: 6px solid #fff;
        }
    }
  }
  .main {
    .topInfo {
      background: #fff;
      padding: 55px 16px 3px;
      .Info {
        border-bottom: 1px dashed #CDCDCD;
        padding-bottom: 16px;
        .nameBox {
          word-wrap: break-word;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .name {
            font-size: 22px;
            font-weight: 600;
            color: #1F262E;
            line-height: 30px;
            flex: 1;
          }
          .opation {
            font-size: 14px;
            font-weight: bolder;
            color: #FFFFFF;
            line-height: 20px;
            background: #DB5851;
            border-radius: 16px;
            padding: 6px 19px;
            margin-left: 4px;
          }
        }
        .slogan {
         margin-top: 7px;
          font-size: 14px;
          font-weight: 400;
          color: #5E6A75;
          line-height: 20px;
         
        }
        .org {
          margin-top: 4px;
          display: flex;
          font-size: 14px;
          font-weight: 400;
          color: #5E6A75;
          line-height: 20px;
          align-items: center;
           img {
            width: 12px;
            height: 12px;
          }
        }
        .scoreBox {
          margin-top: 8px;
          .score {
            display: inline-block;
            i {
              vertical-align: middle;
              position: relative;
              top: -3px;
              display: inline-block;
              width: 16px;
              height: 16px;
            }
            i.full {
              background: url(../../../assets/img/h5/fraction_full_y.png)
                no-repeat;
              background-size: 16px 16px;
            }
            i.half {
              background: url(../../../assets/img/h5/fraction_half_y.png)
                no-repeat;
              background-size: 16px 16px;
            }
            i.none {
              background: url(../../../assets/img/h5/fraction_none_y.png)
                no-repeat;
              background-size: 16px 16px;
            }
            i:not(:last-child) {
              // margin-right: 4px;
            }
            span {
              display: inline-block;
              font-size: 16px;
              font-weight: bold;
              color: #FD8850;
              line-height: 21px;
              margin-left: 4px;
            }
          }
          > span {
            font-size: 12px;
            font-weight: 400;
            color: #7B858F;
            line-height: 18px;
            margin-left: 4px;
          }
        }
      }
      .location {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 0;
        font-size: 12px;
        font-weight: 400;
        color: #7B858F;
        line-height: 18px;
        .address {
          flex: 1;
          overflow: hidden;
          display: flex;
          align-items: center;
          .addtext {
            flex: 1;
          }
        }
        i {
          display: inline-block;
          width: 12px;
          height: 12px;
          margin-right: 2px;
          vertical-align: middle;
          position: relative;
          top: -2px;
        }
         i.locationicon {
          background: url(../../../assets/img/h5/location_g.png) no-repeat;
          background-size: 12px 12px;
        }
         i.arrow {
          background: url(../../../assets/img/h5/arrow_r_h.png) no-repeat;
          background-size: 12px 12px;
          margin-left: 2px;
        }
      }
    }
    .graybg {
      height: 10px;
      background: #F6F7F8;
    }
    .swiperInfo {
      background: #fff;
      .person {
        padding: 31px 16px 0;
        .common {
          .title {
            font-size: 20px;
            font-weight: bolder;
            color: #1F262E;
            margin-bottom: 8px;
          }
          .content {
            font-size: 14px;
            font-weight: 400;
            color: #1F262E;
            line-height: 22px;
          }
        }
        .skill {
          padding-bottom: 24px;
          border-bottom: .5px solid #E8EBED;
        }
        .profile {
          margin-top: 24px;
          .content {
            padding-bottom: 24px;
          }
        }
      }
      .course {
        .commonTop {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          .topLeft {
            .title {
              font-size: 20px;
              color: #1F262E;
              line-height: 28px;
              font-weight: bolder;
              em {
                font-weight: normal;
              }
            }
          }
          .topRight {
            .more {
              font-size: 14px;
              font-weight: 400;
              color: #A1AAB3;
              line-height: 22px;
              padding-right: 20px;
              position: relative;
            }
            .more::before {
              content: " ";
              display: inline-block;
              width: 16px;
              height: 16px;
              background: url(../../../assets/img/h5/arrow_r_g.png) no-repeat;
              background-size: 16px 16px;
              position: absolute;
              right: 0;
              top: 50%;
              margin-top: -8px;
            }
          }
        }
        .online {
          padding: 16px 16px 24px;
          .commonTop {
            margin-bottom: 20px;
          } 
           border-bottom: .5px solid #E8EBED;
           li {
            &:not(:last-child) {
              margin-bottom: 16px;
            }
           }
        }
        .traning {
          padding: 24px 16px;
          .commonTop {
            margin-bottom: 16px;
          }
           li {
            &:not(:last-child) {
              margin-bottom: 12px;
            }
           }
        }
      }
      .interact {
        padding: 23px 16px 24px;
        .face {
          border: 1px solid #E2E5F4 ;
          margin-top: 16px;
          .title {
            background: linear-gradient(134deg, #E2E5F3 0%, #E1E3F5 100%);
          }
          
        }
        .online {
          border: 1px solid #F3E6E5;
          .title {
            background: linear-gradient(134deg, #F3E7E2 0%, #F5E1EE 100%);
          }
        }
        .box_common {
          
          background: linear-gradient(204deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 100%);
          border-radius: 12px;
          overflow: hidden;
          .title {
            
            // border-radius: 12px;
            
            padding: 11px 16px 13px;
            font-size: 20px;
            font-weight: bold;
            color: #1F262E;
            line-height: 28px;
          }
          .paycontent {
            padding: 0 16px;
            ul {
              li {
                &:not(:last-child) {
                  border-bottom: .5px solid #E8EBED;
                }
                padding: 16px 0;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .pay {
                  flex: 1;
                  overflow: hidden;
                  .payTitle {
                    // overflow: hidden;
                    font-size: 16px;
                    font-weight: bolder;
                    color: #1F262E;
                    line-height: 22px;
                    // display: flex;
                    .price {
                      color: #EDAE6D;
                      margin-left: 4px;
                      white-space:nowrap;
                    }
                    .producetitle {
                      // flex: 1;
                    }
                  }
                  .txt {
                    font-size: 12px;
                    font-weight: 400;
                    color: #7B858F;
                    line-height: 18px;
                    margin-top: 4px;
                  }
                }
                .opration {
                  white-space:nowrap;
                  margin-left: 12px;
                  font-size: 14px;
                  font-weight: bolder;
                  color: #FFFFFF;
                  line-height: 20px;
                  padding: 8px 16px;
                  background: linear-gradient(134deg, #D44C48 0%, #EE816D 100%);
                  border-radius: 18px;
                }
              }
            }
          }
        }
        // .online {
        //   li {
        //     &:not(:last-child) {
        //       border-bottom: .5px solid #E8EBED;
        //     }
        //   }
        // }
      }
      .evaluation {
        padding: 7px 16px 16px;
        li {
          margin-top: 24px;
          padding-bottom: 24px;
          &:not(:last-child) {
            border-bottom: .5px solid #E8EBED;
          }
        }
      }
    }
  }

}
</style>
